import React from "react";
import { Link } from "react-router-dom";
import { useWishlist } from "../contexts/WishlistContext";
import { useI18n } from "../i18n";
import ProductCard from "../components/store/ProductCard";

const Wishlist = () => {
  const { items } = useWishlist();
  const { t, lang } = useI18n();
  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-10" data-testid="wishlist-page">
      <h1 className="font-display text-5xl tracking-tighter font-light mb-10">{t("wishlist")}</h1>
      {items.length === 0 ? (
        <div className="py-24 text-center text-ink-muted">
          {lang === "nl" ? "Je verlanglijst is leeg." : "Your wishlist is empty."}
          <div className="mt-4"><Link to="/shop" className="btn-secondary text-sm">{t("nav_shop")}</Link></div>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-12">
          {items.map((p) => <ProductCard key={p.product_id} product={p} />)}
        </div>
      )}
    </div>
  );
};

export default Wishlist;
